module.exports = __webpack_public_path__ + "static/media/emoticon-emoticons-expression-smile-smiley-svgrepo-com.a2e418f3.svg";